import { render } from "./NomeDeUsuario.vue?vue&type=template&id=e3d8bc38"
import script from "./NomeDeUsuario.vue?vue&type=script&lang=js"
export * from "./NomeDeUsuario.vue?vue&type=script&lang=js"
script.render = render

export default script